/**
 * Currency display helper: use database currency_symbol; if blank, use currency_code.
 * No hardcoded currency symbols.
 */

export const getDisplayCurrency = (currencySymbol, currencyCode) => {
  const symbol = (currencySymbol ?? "").toString().trim();
  const code = (currencyCode ?? "").toString().trim();
  return symbol || code || "";
};
